import React from 'react'
import ActiveItems from './ActiveItems'
import BarColor from './BarColor'
import Notification from './Notification'
import SmartRateDisplay from '../smartrate/SmartRateDisplay'

class LoanRow extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      notifications: this.props.loan.notifications,
      ...props
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  dismissNote = (notification_id) => {
    this.setState({ notifications: this.state.notifications.filter(notification => notification.id !== notification_id) })
  };
  renderNotifications = () => {
    const { enableEdit, loan, notifications } = this.state;
    return notifications.filter(note => !note.read).map(notification =>
    (<Notification
      key={notification.id}
      icon={notification.icon}
      enableEdit={enableEdit}
      csrfToken={this.props.csrfToken}
      loanId={loan.id}
      notificationId={notification.id}
      description={notification.description}
      dismissNote={this.dismissNote}
      dismissable={notification.dismissable}
      formattedDate={notification.formatted_date}
    />)
    )
  };
  render() {
    const { toggleDraggable, updateLoanState, csrfToken, isPPP } = this.props;
    const {
      defaultProbability,
      dataPermutation,
      needsRedecision,
      productUsesDefaultModel
    } = this.props.smartRateDisplayProps;
    const { activeTab, customerService, enableEdit, loan, notifications, showActivity } = this.state;
    const barColors = [
      { color: 'green', proc: () => this.props.updateLoanState(loan.app_number, { priority: 'green' }) },
      { color: 'orange', proc: () => this.props.updateLoanState(loan.app_number, { priority: 'orange' }) },
      { color: 'red', proc: () => this.props.updateLoanState(loan.app_number, { priority: 'red' }) },
      { color: 'alpha', proc: () => this.props.updateLoanState(loan.app_number, { priority: 'alpha' }) }
    ]

    return (
      <div colSpan='6'>
        <div className='card'>
          <div className='notification-feed hidden' />
          <BarColor
            appNumber={loan.app_number}
            barColors={barColors}
            csrfToken={csrfToken}
            enableEdit={enableEdit}
            priority={loan.priority}
          />
          <div className='basic-info'>
            {/* Column One */}
            <div className='col'>
              <strong>
                <a target='_blank' href={`/admin/loans/${loan.id}${loan.company_path}`}>
                  {loan.company_name}
                </a>
              </strong>
              <br />
              <a target='_blank'
                href={`/admin/users?id=${loan.borrower_id}`}
                rel="nofollow"
                data-method="post"
              >
                {loan.borrower_name}
              </a>
              <br />
              <p>{loan.app_number}</p>
              {loan.enable_advisor && <span className="new-badge">ADVISOR LOAN</span>}
            </div>
            {/* Column Two */}
            <div className='col'>
              <strong>{loan.amount_format}</strong>
              <br />
              {
                customerService && (
                  <SmartRateDisplay
                    pipeline
                    loanId={loan.id}
                    smartRate={loan.smart_rate}
                    businessName={loan.company_name}
                    color="grey"
                    parentComponent="pipeline"
                    toggleDraggable={toggleDraggable}
                    defaultProbability={defaultProbability}
                    dataPermutation={dataPermutation}
                    needsRedecision={needsRedecision}
                    productUsesDefaultModel={productUsesDefaultModel}
                  />
                )
              }
              <br />
              <a data-remote='true'
                href={`/admin/loans/${loan.id}/notes`}
                data-disable-with="<i class='fa fa-refresh fa-spin spinner'></i>"
              >
                <i className="fa fa-envelope-o" /> Notes
              </a>
            </div>
            {/* Column Three */}
            <div className='col'>
              {customerService &&
                <div>
                  <strong>
                    <a target='_blank' href={`/assist/partners/${loan.partner_url}`}>
                      {loan.partner_name}
                    </a>
                  </strong>
                </div>
              }
              <p className={`${loan.lender_info_key} bank-circle`}>
                {loan.lender_icon_name}
              </p>
            </div>
            <div className='col'>
              <strong>{loan.product_short_name}</strong>
            </div>
            {/* Column Four */}
            <div className='col'>
              <strong>{loan.state}</strong>
            </div>
            {/* Column five */}
            <div className='col'>
              <strong>
                {Boolean(loan.audit_handed_off_at) && activeTab === 'audit'
                  ? loan.audit_handed_off_at
                  : loan.days_since_assigned
                }
              </strong>
            </div>
            {/* Column six */}
            <div className='col'>
              <ActiveItems
                appNumber={loan.app_number}
                csrfToken={csrfToken}
                enableEdit={enableEdit}
                activeItems={loan.active_items}
                updateLoanState={updateLoanState}
              />
            </div>
          </div>
          <div className={`updated-info ${showActivity ? undefined : 'hidden'}`}>
            {notifications.length > 0
              ? this.renderNotifications()
              : <div className='notification'>
                {`There are no new notifications for this loan. The borrower last logged in on ${loan.borrower_last_login}.`}
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default LoanRow
